import {createReducer} from 'redux-act';
import {
  SAVE_DATA_SUCCESS,
  SET_LOADING,
  SAVE_DATA,
  GET_EMAIL_MARKETING_TRIAL_DATE_SUCCESS
} from 'store/storeAppearance/action';

const initialState = () => ({
  loading: false,
  saveSuccess: false,
  emailMarketingTrialDate: null
});

const storeAppearanceReducer = createReducer(
  {
    [SET_LOADING]: (state, payload) => ({
      ...state,
      loading: payload
    }),
    [SAVE_DATA]: (state) => ({
      ...state,
      saveSuccess: false,
      loading: true
    }),
    [SAVE_DATA_SUCCESS]: (state) => ({
      ...state,
      saveSuccess: true,
      loading: false
    }),
    [GET_EMAIL_MARKETING_TRIAL_DATE_SUCCESS]: (state, payload) => {
      return {
        ...state,
        emailMarketingTrialDate: payload.startDate || null
      };
    }
  },
  initialState()
);

export default storeAppearanceReducer;
